﻿
const body = document.querySelector('body');

document.addEventListener('DOMContentLoaded', function (event) {

	const modalButtons = document.querySelectorAll('[data-modal]');
	const modalDismissButtons = document.querySelectorAll('[data-dismiss]');

	modalButtons.forEach((element, index, parent) => {
		element.addEventListener('click', handleClick)
	});

	modalDismissButtons.forEach((element, index, parent) => {
		element.addEventListener('click', handleClick)
	});
});

function handleClick(event) {
	event.preventDefault();
	let modalId = event.currentTarget.dataset.modal;
	let modal = document.querySelector(modalId);
	toggleModal(modal);
}

export function toggleModal(modal) {
	modal.classList.toggle('hidden');
	body.classList.toggle('overflow-hidden');

	let customEvent = new CustomEvent(modal.classList.contains('hidden') ? 'modal.hide' : 'modal.show', { bubbles: true });
	
	modal.dispatchEvent(customEvent);	
}

